import React from 'react';
import styled, { withTheme } from 'styled-components';

const StyledWrapper = styled(
  React.forwardRef(
    // eslint-disable-next-line react/prop-types
    ({ width, height, minHeight, theme, dimensions, ...rest }, ref) => (
      <figure ref={ref} {...rest} />
    )
  )
)`
  position: relative;
  display: block;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  min-height: ${(props) => props.minHeight};
  margin: 0;
`;

export default withTheme(StyledWrapper);
